<ps-header class="header-logo-wrapper ps-margin-bottom-big">
  <ps-header-prefix>
    <img
      class="brand-image-container ps-margin-right-regular"
      alt="brand-image"
      [src]="'svg/header-logo.svg' | brandAsset | async"
    />
    <p class="ps-subtitle-2 ps-color-black-900">{{ 'APP.BUSINESS_REGISTRATION' | translate }}</p>
  </ps-header-prefix>
</ps-header>
